import React from 'react';
import { Icon } from '@/components/ui/Icon';
import { useTheme } from '@/hooks/useTheme';
import { useThemeStore } from '@/stores/themeStore';

export function ThemeToggleButton() {
  const colors = useTheme();
  const resolvedScheme = useThemeStore((s) => (s.preference ?? s.systemScheme));
  const toggleTheme = useThemeStore((s) => s.toggleResolved);

  return (
    <button
      type="button"
      onClick={() => toggleTheme()}
      aria-label={resolvedScheme === 'dark' ? 'Passer en mode jour' : 'Passer en mode nuit'}
      title={resolvedScheme === 'dark' ? 'Mode jour' : 'Mode nuit'}
      style={{
        width: 36,
        height: 36,
        borderRadius: 18,
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${colors.border}`,
        backgroundColor: colors.surface,
        cursor: 'pointer',
      }}
    >
      <Icon
        name={resolvedScheme === 'dark' ? 'sunny-outline' : 'moon-outline'}
        size={20}
        color={colors.text}
      />
    </button>
  );
}
